
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Puneairporturbaniaonrent() {



    const cardData =
    {
        keyword: 'Pune Airport Urbania on Rent  ',
        heading: 'Amruta Travels: Pune Airport Urbania on Rent ',
        headingDescription: 'Amruta Travels offers Pune Airport Urbania on Rent, providing a comfortable and reliable transportation solution for airport pickups and drop-offs. Ideal for families, corporate groups, and tourists, our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities for a smooth airport transfer experience. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels ensures hassle-free and on-time Urbania rentals for Pune Airport travel.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Pune Airport Urbania on rent",
    "description": "Pune Airport Urbania on rent for comfortable and reliable airport transfers. Fully AC luxury Urbania with cushioned pushback seating, ample luggage space, clean interiors, and professional drivers ensures smooth pickup and drop for families, corporate guests, and group travelers."
  },
  {
    "name": "Urbania on rent near Pune Airport",
    "description": "Urbania on rent near Pune Airport with quick availability and timely service. Ideal for airport pickup and drop, featuring air-conditioned interiors, spacious seating, luggage-friendly design, and experienced drivers familiar with airport routes."
  },
  {
    "name": "Force Urbania Pune Airport rentals",
    "description": "Force Urbania Pune Airport rentals offering premium airport transfer solutions. Suitable for family groups, corporate travel, and hotel transfers with AC comfort, luxury seating, ample boot space, and punctual professional drivers."
  },
  {
    "name": "Urbania Bus airport transfer Pune",
    "description": "Urbania bus airport transfer in Pune for group travel and corporate movement. Spacious AC bus with comfortable seating, large luggage space, and trained drivers ensures stress-free airport transportation."
  },
  {
    "name": "Urbania van hire Pune Airport",
    "description": "Urbania van hire at Pune Airport for smooth and safe travel. Luxury AC interiors, cushioned seating, luggage capacity, and professional drivers make it ideal for airport pickup, drop, and hotel transfers."
  },
  {
    "name": "13 seater Urbania Pune Airport pickup",
    "description": "13 seater Urbania Pune Airport pickup service for families and small groups. AC interiors, spacious seating, and ample luggage space with experienced drivers ensure timely and comfortable arrivals."
  },
  {
    "name": "17 seater Urbania Pune Airport drop",
    "description": "17 seater Urbania Pune Airport drop service for larger groups and corporate teams. Premium AC interiors, pushback seating, luggage space, and punctual drivers provide a smooth airport departure experience."
  },
  {
    "name": "Luxury Urbania Pune Airport transfer",
    "description": "Luxury Urbania Pune Airport transfer for premium travelers and VIP guests. High-end AC interiors, plush seating, smooth ride quality, and professional chauffeurs deliver a first-class airport travel experience."
  },
  {
    "name": "AC Urbania hire Pune Airport",
    "description": "AC Urbania hire at Pune Airport for comfortable travel in all weather conditions. Spacious air-conditioned interiors, cushioned seating, and luggage space ensure relaxed airport transfers."
  },
  {
    "name": "Force Urbania airport cab Pune",
    "description": "Force Urbania airport cab in Pune offering safe, reliable, and luxury airport transportation. Ideal for family, corporate, and hotel transfers with AC comfort and trained drivers."
  },
  {
    "name": "Urbania on rent Viman Nagar Airport Pune",
    "description": "Urbania on rent in Viman Nagar near Pune Airport for quick airport pickups and drops. AC interiors, comfortable seating, luggage-friendly space, and professional drivers ensure timely service."
  },
  {
    "name": "Urbania hire near Lohegaon Airport Pune",
    "description": "Urbania hire near Lohegaon Airport Pune for reliable airport transportation. Luxury AC vehicles with spacious seating, ample luggage space, and experienced drivers ensure hassle-free travel."
  },
  {
    "name": "Urbania rental near Yerawada Pune Airport",
    "description": "Urbania rental near Yerawada Pune Airport for convenient and affordable airport transfers. AC comfort, cushioned seating, clean interiors, and professional drivers guarantee smooth journeys."
  },
  {
    "name": "Urbania for Pune Airport family pickup",
    "description": "Urbania for Pune Airport family pickup offering spacious and safe travel. Ideal for families with luggage, featuring AC interiors, comfortable seating, and experienced drivers."
  },
  {
    "name": "Urbania Pune Airport corporate transfer",
    "description": "Urbania Pune Airport corporate transfer service for executives and business teams. Premium AC interiors, professional chauffeurs, punctual service, and luxury comfort ensure stress-free business travel."
  },
  {
    "name": "Urbania Pune Airport hotel transfer",
    "description": "Urbania Pune Airport hotel transfer service for guests and tourists. Comfortable AC interiors, luggage space, and professional drivers provide smooth hotel pickup and drop experiences."
  },
  {
    "name": "Urbania Pune Airport office pickup",
    "description": "Urbania Pune Airport office pickup for corporate staff and business travelers. Reliable AC vehicles with comfortable seating and punctual drivers ensure smooth office transfers."
  },
  {
    "name": "Pune Airport Urbania rent price",
    "description": "Pune Airport Urbania rent price with transparent and competitive rates. Flexible pricing options available for pickup, drop, and hourly airport transfers without hidden charges."
  },
  {
    "name": "Urbania Pune Airport per km rate",
    "description": "Urbania Pune Airport per km rate for flexible travel needs. Ideal for airport pickups, drops, and hotel transfers with AC comfort, spacious seating, and professional drivers."
  },
  {
    "name": "Affordable Urbania Pune Airport transfer",
    "description": "Affordable Urbania Pune Airport transfer offering budget-friendly pricing with premium comfort. AC interiors, spacious seating, and trained drivers ensure value-for-money service."
  },
  {
    "name": "Best Urbania Airport cab Pune",
    "description": "Best Urbania Airport cab in Pune known for reliability, punctuality, and comfort. Luxury AC vehicles with professional drivers ensure smooth airport transfers."
  },
  {
    "name": "Cheap Urbania Pune Airport Rentals",
    "description": "Cheap Urbania Pune Airport rentals providing economical airport transport without compromising comfort. AC interiors, clean seating, and skilled drivers ensure safe and affordable travel."
  },
  {
    "name": "Book Urbania Pune Airport",
    "description": "Book Urbania Pune Airport easily for pickup and drop services. Simple booking process, AC luxury vehicles, and experienced drivers ensure hassle-free airport transportation."
  },
  {
    "name": "Online Urbania Airport booking Pune",
    "description": "Online Urbania Airport booking in Pune for quick and convenient reservations. Well-maintained AC vehicles, spacious seating, and professional drivers ensure timely airport transfers."
  },
  {
    "name": "Hire Urbania Pune Airport with driver",
    "description": "Hire Urbania Pune Airport with driver for stress-free travel. Trained chauffeurs, AC interiors, luggage-friendly design, and smooth rides ensure premium airport transportation."
  },
  {
    "name": "Urbania Airport cab Pune contact number",
    "description": "Urbania Airport cab Pune contact service offering quick assistance and booking support. Reliable AC Urbania vehicles with professional drivers ensure prompt airport transfers."
  },
  {
    "name": "Pune Airport Urbania on Rent with Driver",
    "description": "Pune Airport Urbania on rent with driver for safe and comfortable airport travel. AC interiors, cushioned seating, ample luggage space, and experienced drivers ensure smooth pickup and drop."
  },
  {
    "name": "13 & 17 Seater Urbania Airport Transfer Pune",
    "description": "13 & 17 seater Urbania Airport transfer in Pune for families and groups. Spacious AC interiors, comfortable seating, luggage capacity, and professional drivers make group airport travel easy."
  },
  {
    "name": "Luxury Force Urbania Pune Airport Pickup & Drop",
    "description": "Luxury Force Urbania Pune Airport pickup & drop service for premium travelers. High-end AC interiors, plush seating, smooth ride quality, and professional chauffeurs deliver a luxury airport experience."
  }
],
"tableData": [
  ["Pune Airport Urbania on rent", "Urbania on rent near Pune Airport"],
  ["Force Urbania Pune Airport rentals", "Urbania Bus airport transfer Pune"],
  ["Urbania van hire Pune Airport", "13 seater Urbania Pune Airport pickup"],
  ["17 seater Urbania Pune Airport drop", "Luxury Urbania Pune Airport transfer"],
  ["AC Urbania hire Pune Airport", "Force Urbania airport cab Pune"],
  ["Urbania on rent Viman Nagar Airport Pune", "Urbania hire near Lohegaon Airport Pune"],
  ["Urbania rental near Yerawada Pune Airport", "Urbania for Pune Airport family pickup"],
  ["Urbania Pune Airport corporate transfer", "Urbania Pune Airport hotel transfer"],
  ["Urbania Pune Airport office pickup", "Pune Airport Urbania rent price"],
  ["Urbania Pune Airport per km rate", "Affordable Urbania Pune Airport transfer"],
  ["Best Urbania Airport cab Pune", "Cheap Urbania Pune Airport Rentals"],
  ["Book Urbania Pune Airport", "Online Urbania Airport booking Pune"],
  ["Hire Urbania Pune Airport with driver", "Urbania Airport cab Pune contact number"],
  ["Pune Airport Urbania on Rent with Driver", "13 & 17 Seater Urbania Airport Transfer Pune"],
  ["Luxury Force Urbania Pune Airport Pickup & Drop", "Urbania Bus airport transfer Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune Airport Urbania on Rent",
    "WhyChoosedescription": "Amruta Travels offers Pune Airport Urbania on Rent, providing a comfortable, spacious, and reliable travel solution for airport transfers. Ideal for group pickups and drops with luggage."
  },
  {
    "WhyChooseheading": "Perfect for Airport Pickup and Drop Services",
    "WhyChoosedescription": "Whether it’s an early-morning pickup or late-night drop, our Urbania airport rental service ensures timely, stress-free, and comfortable transfers to and from Pune Airport."
  },
  {
    "WhyChooseheading": "Spacious Interiors with Luggage Comfort",
    "WhyChoosedescription": "Our Urbania vehicles offer plush seating, ample legroom, air conditioning, large windows, and generous luggage space, making them ideal for airport travel with baggage."
  },
  {
    "WhyChooseheading": "Professional and Punctual Drivers",
    "WhyChoosedescription": "All airport Urbania rentals include trained drivers who track flight timings, ensure punctual arrivals, and provide a smooth and safe airport transfer experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive and transparent pricing for Pune Airport Urbania rentals, with no hidden charges, giving you excellent value for airport transportation."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "Our Urbania vehicles are regularly serviced and sanitized to maintain high standards of hygiene, safety, and comfort for airport travelers."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop Locations",
    "WhyChoosedescription": "We provide flexible pickup and drop locations across Pune, making airport transfers convenient for hotels, offices, homes, and business hubs."
  },
  {
    "WhyChooseheading": "Easy Booking with 24/7 Support",
    "WhyChoosedescription": "Booking Pune Airport Urbania on Rent is quick and hassle-free with Amruta Travels. Our support team is available to assist you anytime for seamless airport travel."
  }
]

    }

const faqData = [
  {
    question: 'How can I book an Urbania on rent for Pune Airport?',
    answer: 'You can book an Urbania for Pune Airport by contacting Amruta Travels online, via phone, or by visiting our office. Our team will assist you with pickup or drop scheduling.'
  },
  {
    question: 'Is Urbania suitable for airport transfers with luggage?',
    answer: 'Yes, Urbania is ideal for airport transfers as it offers spacious seating and ample luggage space, making group travel with baggage comfortable.'
  },
  {
    question: 'Do drivers track flight timings for airport pickups?',
    answer: 'Yes, our drivers monitor flight schedules to ensure timely airport pickups and drops, minimizing waiting time and delays.'
  },
  {
    question: 'Does the airport Urbania rental include a driver?',
    answer: 'Yes, every Pune Airport Urbania rental includes a professional, experienced driver for a safe and smooth transfer.'
  },
  {
    question: 'Are Urbania vehicles sanitized for airport travel?',
    answer: 'Absolutely. All Urbania vehicles are thoroughly cleaned and sanitized before every airport trip.'
  },
  {
    question: 'What is the cost of renting an Urbania for Pune Airport?',
    answer: 'The cost depends on pickup/drop distance, timing, and duration. Contact Amruta Travels for a transparent and customized airport rental quote.'
  },
  {
    question: 'Can I book Urbania for late-night or early-morning airport transfers?',
    answer: 'Yes, our Pune Airport Urbania rental service is available 24/7, including late-night and early-morning pickups and drops.'
  },
  {
    question: 'Why choose Amruta Travels for Pune Airport Urbania on Rent?',
    answer: 'Amruta Travels offers punctual service, well-maintained Urbania vehicles, professional drivers, transparent pricing, and reliable airport transfer support.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Kunal Joshi',
    role: 'Business Traveler, Pune',
    text: 'Booked an Urbania for airport pickup. The vehicle arrived on time, was very spacious for luggage, and the driver was professional. Excellent service by Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Nisha Kulkarni',
    role: 'Family Traveler, Pune',
    text: 'Used Pune Airport Urbania on rent for a family airport drop. The ride was comfortable and stress-free. Highly recommend Amruta Travels for airport transfers!',
    rating: 5
  }
];






















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport Urbania on Rent",
  "image": "https://bushireinpune.com/assets/images/pune-airport-urbania-rent.jpg",
  "description": "Hire Urbania on rent for Pune Airport transfers with Amruta Travels. Luxury 13 & 17 seater Force Urbania vans available for airport pickup, drop, corporate transfers, family trips, and hotel or office transport. Services available near Lohegaon Airport, Viman Nagar, Yerawada, and across Pune city with professional drivers and affordable per km rates.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2880"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7500",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-airport-urbania-on-rent"
  }
};



    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Pune Airport Urbania on Rent | Force Urbania Airport Transfers</title>
  <meta
    name="description"
    content="Pune Airport Urbania on rent with Amruta Travels. Hire 13 & 17 seater Force Urbania vans for airport pickup, drop, corporate transfers, family trips, and hotel transport at affordable rates."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/109.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Puneairporturbaniaonrent;